import React from 'react';
import { Pressable, View } from 'react-native';
import Text from '@/components/Typography/Text';

export default function HtmlPreviewVersions({ history }) {
  if (history.versions.length < 2) return null;
  return <View accessibilityLabel="Preview versions" style={{ flexDirection: 'row', flexWrap: 'wrap', gap: 12 }}>
    {history.versions.map((version, index) => <Pressable key={version.id} accessibilityRole="button" accessibilityState={{ selected: version.id === history.selectedId }}
      onPress={() => history.select(version.id)} style={{ minHeight: 36, paddingVertical: 8, paddingHorizontal: 4 }}>
      <Text size="xs" color={version.id === history.selectedId ? 'primary' : 'secondary'}>{index === 0 ? 'Current version' : `Earlier version ${index}`}</Text>
    </Pressable>)}
  </View>;
}
